export default __webpack_public_path__ + "static/media/news_2.d09bac4a.png";